import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import IntArrayList from '../../util/IntArrayList';
import ArrayList from '../../../../../java/util/ArrayList';
import Quadrant from '../Quadrant';
var MonotoneChainIndexer = /*#__PURE__*/function () {
  function MonotoneChainIndexer() {
    _classCallCheck(this, MonotoneChainIndexer);
  }
  _createClass(MonotoneChainIndexer, [{
    key: "getChainStartIndices",
    value: function getChainStartIndices(pts) {
      var start = 0;
      var startIndexList = new IntArrayList(Math.trunc(pts.length / 2));
      startIndexList.add(start);
      do {
        var last = this.findChainEnd(pts, start);
        startIndexList.add(last);
        start = last;
      } while (start < pts.length - 1);
      return startIndexList.toArray();
    }
  }, {
    key: "findChainEnd",
    value: function findChainEnd(pts, start) {
      var chainQuad = Quadrant.quadrant(pts[start], pts[start + 1]);
      var last = start + 1;
      while (last < pts.length) {
        var quad = Quadrant.quadrant(pts[last - 1], pts[last]);
        if (quad !== chainQuad) break;
        last++;
      }
      return last - 1;
    }
  }, {
    key: "OLDgetChainStartIndices",
    value: function OLDgetChainStartIndices(pts) {
      var start = 0;
      var startIndexList = new ArrayList();
      startIndexList.add(start);
      do {
        var last = this.findChainEnd(pts, start);
        startIndexList.add(last);
        start = last;
      } while (start < pts.length - 1);
      var startIndex = MonotoneChainIndexer.toIntArray(startIndexList);
      return startIndex;
    }
  }], [{
    key: "toIntArray",
    value: function toIntArray(list) {
      var array = new Array(list.size()).fill(null);
      for (var i = 0; i < array.length; i++) array[i] = list.get(i).intValue();
      return array;
    }
  }]);
  return MonotoneChainIndexer;
}();
export { MonotoneChainIndexer as default };